require("core-js/modules/es6.array.map");

var CSG = require('../core/CSG');

var _require = require('./primitives3d'),
    cube = _require.cube; // For debugging
// Creates a new solid with a tiny cube at every vertex of the source solid
// this is seperated from the CSG class itself because of the dependency on cube


var toPointCloud = function toPointCloud(csg, cuberadius) {
  csg = csg.reTesselated();
  var result = new CSG(); // make a list of all unique vertices
  // For each vertex we also collect the list of normals of the planes touching the vertices

  var vertexmap = {};
  csg.polygons.map(function (polygon) {
    polygon.vertices.map(function (vertex) {
      vertexmap[vertex.getTag()] = vertex.pos;
    });
  });

  for (var vertextag in vertexmap) {
    var pos = vertexmap[vertextag];

    var _cube = cube({
      center: pos,
      radius: cuberadius
    });

    result = result.unionSub(_cube, false, false);
  }

  result = result.reTesselated();
  return result;
};

module.exports = {
  toPointCloud: toPointCloud
};